import api from './api';

const walletService = {
  get: () => api.get('/wallet'),
  getTransactions: (params) => api.get('/wallet/transactions', { params }),
  applyReferral: (code) => api.post('/wallet/apply-referral', { code }),
  topUp: (amount) => api.post('/wallet/top-up', { amount }),
  useBalance: (amount, orderId) => api.post('/wallet/use', { amount, orderId }),
};

export default walletService;
